import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgHelpIconSecondary from './svgs/HelpIconSecondary.js';
import SvgHelpIcon from './svgs/HelpIcon.js';
import { useIcon } from '../../shared-components/icon/index.js';

var helpIcon = (props => useIcon(SvgHelpIcon, SvgHelpIconSecondary, props));

export { helpIcon as default };
